export type {
  BannerAsideProps as HeroAsideProps,
  BannerBackgroundProps as HeroBackgroundProps,
  BannerContentProps as HeroContentProps,
  BannerHeaderProps as HeroHeaderProps,
  BannerProps as HeroProps,
} from "@webmotors/eleanor-ui";

export * from "./bannerds.component";
